import {Routes} from '@angular/router';
import {AdminLayoutComponent} from './layout/admin-layout/admin-layout.component';
import {AuthLayoutComponent} from './layout/auth-layout/auth-layout.component';
import {NotFoundComponent} from './pages/other-pages/not-found/not-found.component';
import {authGuard} from './core/guards/auth.guard';
import {roleGuard} from './core/guards/role.guard';
import {WebsiteLayoutComponent} from './layout/website-layout/website-layout.component';


export const routes: Routes = [

  /* =======================
   * USER HOME (DEFAULT)
   * ======================= */
  {
    path: '',
    component: WebsiteLayoutComponent,
    loadChildren: () =>
      import('./features/user-home/user-home.routes')
        .then(m => m.USER_HOME_ROUTES),
  },


  /* =======================
   * AUTH LAYOUT
   * ======================= */
  {
    path: 'auth',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/auth/auth.routes')
            .then(m => m.AUTH_ROUTES),
      }
    ],
  },


  /* =======================
   * ADMIN LAYOUT
   * ======================= */
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [authGuard, roleGuard],
    data: { roles: ['ADMIN'] },
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/admin/admin.routes')
            .then(m => m.ADMIN_ROUTES),
      },
     /* {
        path: 'competition',
        loadChildren: () =>
          import('./features/competition/competition.routes')
            .then(m => m.COMPETITION_ROUTES),
      },
      {
        path: 'booking',
        loadChildren: () =>
          import('./features/booking/booking.routes')
            .then(m => m.BOOKING_ROUTES),
      },*/
    ],
  },


  /* =======================
   * JUDGE PANEL
   * ======================= */
  /*{
    path: 'judge',
    component: AdminLayoutComponent,
    canActivate: [authGuard, roleGuard],
    data: { roles: ['JUDGE'] },
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/competition/judge/judge.routes')
            .then(m => m.JUDGE_ROUTES),
      },
    ]
  },*/


  /* =======================
   * PARTICIPANT
   * ======================= */
 /* {
    path: 'participant',
    loadChildren: () =>
      import('./features/competition/participant/participant.routes')
        .then(m => m.PARTICIPANT_ROUTES),
  },*/


  /* =======================
   * ACCESS DENIED
   * ======================= */
  {
    path: 'access-denied',
    loadComponent: () =>
      import('./pages/other-pages/not-found/not-found.component')
        .then(m => m.NotFoundComponent),
  },


  /* =======================
   * 404
   * ======================= */
  {
    path: '**',
    component: NotFoundComponent,
  },

];

